module.exports = __webpack_public_path__ + "img/home_bg.e68ca96f.png";